<template>
  <b-modal
    title="Add Keyword"
    ref="add-keyword-modal"
    id="add-keyword-modal"
    size="lg"
    ok-title="Add"
    @ok="addKeyword"
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <validation-observer ref="addKeywordRule" tag="form">
        <b-form-group label-for="keyword">
          <div style="display:inline-block; width: 10%;">KEYWORD<span class="text-danger">*</span></div>
          <validation-provider
            #default="{ errors }"
            name="Keyword"
            rules="required"
          >
          <b-form-input
            id="keyword"
            v-model="keyword.keyword"
            placeholder="키워드"
            style="display:inline-block; width:43%; margin-left:1rem;"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <validation-provider #default="{ errors }" name="Type" rules="required">
          <div class="d-flex align-items-center mt-3">
            <div style="display:inline-block; width: 10%;">TYPE <span class="text-danger">*</span></div>
            <vue-select
              id="type"
              v-model="keyword.type"
              :options="types"
              :state="errors.length > 0 ? false : null"
              :reduce="(option) => option.type"
              label="name"
              placeholder="Type"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>

      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import CISSettingService from '@/services/cis-setting.service'

export default {
  name: "AddKeywordModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    refreshData: {
      type: Function,
      default: () => {},
    },
    targetRmKeyword: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      types: [
        {name: '공동', type: 'public'},
        {name: '개별', type: 'private'},
        {name: '데드(포함)', type: 'in_del'},
        {name: '데드(일치)', type: 'ex_del'},
        {name: '라이브(포함)', type: 'in_liv'},
        {name: '라이브(일치)', type: 'ex_liv'}
      ],
      keyword: {},
      required,
    };
  },
  watch: {
    targetRmKeyword(val) {
      if (val && val.length > 0) 
        this.keyword.keyword = val;
    }
  },
  methods: {
    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.addKeywordRule.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject("");
          }
        });
      });
    },
    async addKeyword(e) {
      e.preventDefault();
      await this.checkInfo();

      this.$swal({
        title: "Are you sure?",
        html: `You want to add the Keyword!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {
          var ctgSq = this.$store.getters.getSelectedCategory
          if(ctgSq == '9999'){
            ctgSq = 1
          }
          this.keyword.ctgSq = ctgSq
          const response = await CISSettingService.addKeyword(this.keyword);
          if (response && response.status === 200) {
            this.keyword = {};
            this.$bvModal.hide("add-keyword-modal");
            this.refreshData();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully added!`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
  },
  created() {
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>